/** Default keys in event data to redact */
export const defaultKeysToSanitize = [
  /password/i,
  /token/i,
  /secret/i,
  /passwd/i,
  /authorization/i,
  /api_key/i,
  /apikey/i,
  /sentry_dsn/i,
  /access_token/i,
];

/**
 * Default errors to ignore (will be merged with user's list)
 *
 * @deprecated This should not be the default because it's very specific to Ads manager
 */
export const defaultErrorsToIgnore: (string | RegExp)[] = [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
] as const;
